module.exports = __webpack_public_path__ + "static/media/Group.d3929abd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Group.svg
// module id = 318
// module chunks = 0